import { Button, Form } from "@themesberg/react-bootstrap";
import React from "react";

export const TableRow = (props) => {
  const { ticket, user, netValue, tax, fee, grossValue, isPaid, id } =
    props.data;
  const { isSelected, onSelect, onRecalculatePress, onDeletePress } = props;

  return (
    <tr>
      <td className="text-center">
        <Form.Check
          type="checkbox"
          checked={isSelected || false}
          onChange={(e) => onSelect(id, e.target.checked)}
          disabled={isPaid}
        />
      </td>
      <td className="text-center">
        {ticket?.ClassicLotteryStorage?.images ? (
          <div
            className="rounded overflow-hidden d-inline-block"
            style={{ width: 48, height: 48, cursor: "pointer" }}
            onClick={() => {
              if (props.onPreviewImage) {
                props.onPreviewImage(`Ảnh vé ${ticket.id || ""}`, ticket.ClassicLotteryStorage.images);
              }
            }}
          >
            <img
              src={ticket.ClassicLotteryStorage.images}
              alt="Ticket"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              onError={(e) => {
                e.target.parentElement.style.display = "none";
              }}
            />
          </div>
        ) : (
          <span className="text-muted small">-</span>
        )}
      </td>
      <td className="text-center">
        {!isPaid && (
          <>
            &nbsp; &nbsp; &nbsp;
            <Button
              className="btn-danger"
              onClick={() => props.onPaidPress(id, user.phone, ticket.id)}
            >
              Trả thưởng
            </Button>
            &nbsp; &nbsp;
            <Button
              className="btn-warning"
              onClick={() => onRecalculatePress && onRecalculatePress(id)}
            >
              Tính lại
            </Button>
            &nbsp; &nbsp;
            <Button
              className="btn-secondary"
              onClick={() => onDeletePress && onDeletePress(id)}
            >
              Xóa
            </Button>
          </>
        )}
      </td>
      <td>
        {(user && user.name) || ""}
        <br />
        <span>
          <strong className={`text-primary`}>
            {(user && user.phone) || ""}
          </strong>
        </span>
      </td>
      <td className="text-center">
        <div className="d-flex align-items-center justify-content-center gap-2">
          {ticket.ClassicLotteryChannel.logo && (
            <img
              src={ticket.ClassicLotteryChannel.logo}
              alt={ticket.ClassicLotteryChannel.name}
              className="rounded-circle border border-gray-200"
              style={{ width: "24px", height: "24px", objectFit: "cover" }}
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
          )}
          <div className="text-start">
            <div>{ticket.ClassicLotteryChannel.name}</div>
            <div className="small text-muted">
              {ticket.ClassicResult.resultDate}
            </div>
          </div>
        </div>
      </td>
      <td className="text-center">
        {ticket.ClassicLotteryStorageId.slice(-6) +
          " x " +
          ticket.amount +
          " tờ"}
      </td>
      <td className="text-center">
        {new Intl.NumberFormat("vn-VI", {}).format(grossValue)}
      </td>
      <td className="text-center text-danger">
        {new Intl.NumberFormat("vn-VI", {}).format(tax)}
      </td>
      <td className="text-center text-warning">
        {new Intl.NumberFormat("vn-VI", {}).format(fee)}
      </td>
      <td className="text-center text-success">
        {new Intl.NumberFormat("vn-VI", {}).format(netValue)}
      </td>
    </tr>
  );
};
